import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PointsAirIndiaIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.47483 13.2748C3.55443 12.8638 1.30762 10.3548 1.30762 7.32104C1.30762 4.00032 3.99959 1.30835 7.32031 1.30835C10.3539 1.30835 12.8627 3.55487 13.2739 6.475C11.8182 6.76814 10.4941 7.4248 9.40035 8.34623C9.40558 8.2936 9.4082 8.23962 9.4082 8.18429C9.4082 7.8305 9.29498 7.55454 9.06856 7.35642C8.84685 7.15358 8.49306 7.00971 8.00719 6.9248L7.57556 6.85404V5.93418C7.76425 5.9672 7.95766 6.02145 8.15578 6.09693C8.35862 6.1724 8.57089 6.27146 8.7926 6.39411L9.2596 5.51671C9.00959 5.36576 8.73835 5.24547 8.44589 5.15584C8.15814 5.0615 7.86803 5.00018 7.57556 4.97187V4.37043H7.05903V4.95065C6.70052 4.9648 6.39154 5.0332 6.1321 5.15584C5.87265 5.27377 5.67453 5.44124 5.53773 5.65823C5.40093 5.87522 5.33253 6.13231 5.33253 6.42949C5.33253 6.81158 5.43159 7.10405 5.62972 7.30689C5.83256 7.50973 6.16276 7.65125 6.62033 7.73144L7.05903 7.81635V8.72205C6.59203 8.64186 6.17219 8.4343 5.79954 8.09938L5.23347 8.92017C5.46933 9.13245 5.74293 9.30462 6.05426 9.43671C6.37032 9.56407 6.70524 9.6419 7.05903 9.67021V10.2717H7.57556V9.67728C7.8 9.66634 8.0046 9.63792 8.18933 9.59203C7.35004 10.6476 6.75098 11.9027 6.47483 13.2748ZM7.05903 6.80451V5.89173C6.85619 5.90116 6.69345 5.94598 6.5708 6.02617C6.45287 6.10164 6.3939 6.20542 6.3939 6.3375C6.3939 6.43657 6.41277 6.51912 6.45051 6.58516C6.48825 6.64648 6.54721 6.69365 6.6274 6.72667C6.71231 6.75969 6.82553 6.78328 6.96704 6.79743L7.05903 6.80451ZM7.57556 8.75743C7.79727 8.74328 7.97417 8.69611 8.10625 8.61591C8.23833 8.53572 8.30437 8.42958 8.30437 8.2975C8.30437 8.20316 8.28786 8.13004 8.25484 8.07815C8.22182 8.02155 8.15814 7.97909 8.06379 7.95079C7.97417 7.91777 7.84444 7.88946 7.67462 7.86588L7.57556 7.85173V8.75743Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.8385 7.3092C14.3226 7.3092 13.8187 7.36035 13.3315 7.45784C10.3576 8.05292 8.0074 10.3748 7.37088 13.3335C7.25894 13.8539 7.2 14.3939 7.2 14.9477C7.2 19.1664 10.6199 22.5863 14.8385 22.5863C19.0572 22.5863 22.4771 19.1664 22.4771 14.9477C22.4771 10.7291 19.0572 7.3092 14.8385 7.3092ZM16.0585 13.3861L16.6528 15.6139C16.6528 15.6139 19.2 13.4752 19.2 13.3861H16.0585ZM14.5302 16.8614L11.7283 18.9109L12.8321 15.5248L10.2 13.3861H13.4264L14.7 10L17.3321 19L14.5302 16.8614Z"
				fill="currentColor"
			/>
			<path
				d="M4.5 15H3.5V16.5H2L2 17.5H3.5V19H4.5V17.5H6V16.5H4.5V15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PointsAirIndiaIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PointsAirIndiaIcon;
